import { loadNg1Module, ngmodule } from '../bootstrap/ngmodule'
import './account/account.module'
import { ApiFactory, apiConfigBlock, otherwiseConfigBlock, traceRunBlock } from './app.config'
import './customers/customers.module'
import './documents/documents.module'
import './errors/errors.module'
import './faqs/faqs.module'
import './orders/orders.module'
import './profile/profile.module'
import './reports/reports.module'
import './shared/shared.module'
import './support/support.module'
import './tasksites/tasksites.module'
import { themeConfig } from './themes/documentus.theme'
import './users/users.module'

const mainAppModule = {
  configBlocks: [apiConfigBlock, otherwiseConfigBlock, themeConfig],
  runBlocks: [traceRunBlock],
  factories: { ApiFactory },
}

loadNg1Module(ngmodule, mainAppModule)



// WEBPACK FOOTER //
// ./app/app.module.js